module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Control-9db78f08f0324a7c3bd11a2c7cfd74d3.svg";